import React from 'react';
import _ from 'lodash';
import cx from 'classnames';



export const Label = ({ className, ...props }) => (
  <label className={cx(className)} {...props} />);
export default Label;